/* eslint arrow-body-style: ["error", "always"] */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { HELP_URL } from '../../constants/HelpFile';

class LeftMainmenuItem extends Component {
    render() {
        const getContent = () => {
            const additionalStyles = {};
            if (this.props.disabled) {
                additionalStyles.color = '#a1a1a1';
            }

            return (
                <div className="row">
                    <div className="col-md-2">
                        <i style={{ marginTop: 6 }} className={`${this.props.icon} spark-icon--md`} />
                    </div>
                    <div className="col-md-10 leftnav-menu-item-copy">
                        <div className="row">
                            <div className="col-md-12">
                                <h3 style={{ marginBottom: 0, ...additionalStyles }}>{this.props.title}</h3>
                                {this.props.copy && <p>{this.props.copy}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            );
        };
        if (this.props.disabled) {
            return (
                <div className="container" style={{ margin: '20 0' }}>
                    <a disabled>{getContent()}</a>
                </div>
            );
        } else if (this.props.link !== '/help') {
            return (
                <div className="container" style={{ margin: '20 0' }}>
                    {this.props.link ? <Link to={this.props.link}>{getContent()}</Link> : getContent()}
                </div>
            );
        } else {
            return (
                <div className="container" style={{ margin: '20 0' }}>
                    {this.props.link ? (
                        <a href={HELP_URL} target="_blank" rel="noopener noreferrer">
                            {getContent()}
                        </a>
                    ) : (
                        getContent()
                    )}
                </div>
            );
        }
    }
}

LeftMainmenuItem.defaultProps = {
    disabled: false
};

LeftMainmenuItem.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    copy: PropTypes.string,
    link: PropTypes.string,
    disabled: PropTypes.bool
};

export default LeftMainmenuItem;



// WEBPACK FOOTER //
// ./src/components/helpers/LeftMainmenuItem.js